angular
  .module('contrast.factory.user.rasp', [])
  .factory('UserRASPFactory', function ($http, UserService) {
    'ngInject'

    return {
      updateEnabled: function (uid, enabled) {
        return $http.put(
          UserService.buildAPIUrl('/rasp/users/' + uid + '/access'),
          { enabled: enabled }
        )
      },
      getRaspUsersBase: function (excludeCurrent) {
        return $http.get(UserService.buildAPIUrl('/rasp/users'), {
          params: {
            base: true,
            excludeCurrent: excludeCurrent
          }
        })
      }
    }
  })
